<template>
  <label for="resources-multiselect-component" class="form-label">
    {{ $t('resource.name') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedResource"
    :options="{
      create: false,
      placeholder: $t('resource.select')
    }"
    class="w-full"
  >
    <option value="null" key="_null">{{ $t('resource.nullSelect') }}</option>
    <option
      v-for="resource in resources"
      :value="resource.uuid"
      :key="resource.uuid"
    >
      {{ resource.internalName }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import resourceApi from '../../services/resources/resource.api'

export default defineComponent({
  data() {
    return {
      resources: []
    }
  },
  mounted() {
    resourceApi.getList(1, 100).then(
      response => {
        this.resources = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedResource: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedResource'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedResource,
      set: value => emit('update:selectedResource', value)
    })

    return {
      componentValue
    }
  }
})
</script>
